import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { TickSvgIcon } from '../../Common/Assets/SvgComponent/commonSvgIcon';
import s from './CoverSection.css';

const CoverSection = ({ data }) => {

  return (
    <div className={cx(s.bg)}>
      <Grid className={s.container}>
        <Row className={s.coveredSection}>
          <Col xs={12} sm={12} md={6} lg={6}>
            <div className={s.centerimgsection} style={{ backgroundImage: `url(/images/home/${data && data.coverSectionImage1})` }}>
            </div>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} className={s.paddingLeft}>
            <div className={cx(s.mainhedding, 'mainheddingRTLMobile')}>
              <h1>{data && data.coverSectionTitle1}</h1>
            </div>
            <p className={cx(s.common)}>{data && data.coverSectionContent1}</p>
            {data &&
              <ul className={s.coveredSectionUl}>
                {
                  [data?.coverSectionFeature1, data?.coverSectionFeature2, data?.coverSectionFeature3, data?.coverSectionFeature4, data?.coverSectionFeature5, data?.coverSectionFeature6]?.map((item, index) => {
                    return (
                      <li key={index}><TickSvgIcon />{item}</li>
                    )
                  })
                }
              </ul>
            }
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

CoverSection.propTypes = {
  formatMessage: PropTypes.any,
  refer: PropTypes.string,
};

export default withStyles(s)(CoverSection);
